import React from 'react';
import { Tabs as AntTabs, TabsProps as AntTabsProps } from '@vertem-core/vertice-ds';

const Tabs: React.FC<AntTabsProps> & {
  TabPane: typeof AntTabs.TabPane;
} = (props) => <AntTabs {...props} />;

// Assign TabPane to your custom Tabs component
Tabs.TabPane = AntTabs.TabPane;

export default Tabs;
